import { PaymentISOs } from 'utils/form/constants';

export enum TransactionType {
  PAYMENT = 'payment',
  PREPAID = 'prepaid',
}

interface IGetGooglePaymentsConfigs {
  transactionType: TransactionType;
  countryCode: PaymentISOs;
  googleConfig: {
    [key in string]: any;
  };
}

/**
 * This function return the Google Pay transaction configs based on the transaction type and countrycode
 * It is returning the gateway and the gateway merchant id
 */
export const getGooglePaymentsConfigs = ({
  transactionType,
  countryCode,
  googleConfig,
}: IGetGooglePaymentsConfigs) => {
  // Checking if it's a prepaid or a payment transaction
  const isPayment = transactionType === TransactionType.PAYMENT;

  const {
    paymentsGateway,
    prepaidPaymentsGateway,
    paymentsGatewayMerchantId,
    prepaidPaymentsGatewayMerchantId,
  } = googleConfig;

  // Getting the right gateway based on the transaction type
  const gateway = isPayment ? paymentsGateway : prepaidPaymentsGateway;

  // Getting the gateway merchant id based on the transaction type and the country code of the transaction
  let gatewayMerchantId;
  switch (countryCode) {
    case PaymentISOs.CA:
      if (isPayment) {
        gatewayMerchantId = paymentsGatewayMerchantId.ca;
      } else {
        gatewayMerchantId = prepaidPaymentsGatewayMerchantId.ca;
      }
      break;
    case PaymentISOs.US:
      if (isPayment) {
        gatewayMerchantId = paymentsGatewayMerchantId.us;
      } else {
        gatewayMerchantId = prepaidPaymentsGatewayMerchantId.us;
      }
      break;
    default:
      gatewayMerchantId = '';
  }

  // Returning the right conf
  return { gateway, gatewayMerchantId };
};
